import { cn } from "@/utils/cn";

export default function MainGrid({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <div
      className={cn("max-w-[1640px] w-full mx-auto px-10 py-10 ", className)}
    >
      {children}
    </div>
  );
}
